import { useSearchProductOpened } from './useSearchProductOpened'
import { changeSearchOpen } from '@/features/pos/components/ProductCatalog/utils/changeSearchOpen'
import { changeSearchProduct } from '@/features/pos/components/ProductCatalog/utils/changeSearchProduct'
import { useConfigurableProductId } from '@/features/pos/contexts/ConfigurableProductId'
import { useEffect } from 'react'

export const useHideSearchOnProductSelect = (): void => {
    const productId = useConfigurableProductId()
    const searchOpened = useSearchProductOpened()

    useEffect(() => {
        if (!productId || !searchOpened) return

        changeSearchOpen(false)
        changeSearchProduct('')
    }, [productId, searchOpened])
}
